<template>
    <div class="mysub">
        <myScroll class="scroll" @handle-scroll="handleScroll">
            <div class="myinfo">
                <div class="cod" v-if="coinfo.infotype==2">
                    <div class="codheader">
                        <div class="codtitle">{{coinfo.title}}</div>
                        <dl class="codabout">
                            <dt>
                                <span v-if="coinfo.showname">{{coinfo.showname}}</span>{{$common.basic.dateformat(coinfo.publishdate,'yyyy-MM-dd hh:mm:ss')}}
                            </dt>
                            <dd><ffcounts :options="coinfo.x_counts"></ffcounts></dd>
                        </dl>
                    </div>
                    <div class="cocon editor2" v-html="coinfo.content"></div>
                </div>
                <div class="cod" v-else>
                    <div class="codheader">
                        <div class="codtitle">{{coinfo.eventother||coinfo.eventtitle}}</div>
                        <div class="codabout2">
                            <dl>
                                <dd><img :src="coinfo.x_avatar" /></dd>
                                <dt>
                                    <span>{{coinfo.x_showname}}</span>{{$common.basic.dateformat(coinfo.publishdate,'yyyy-MM-dd hh:mm:ss')}}
                                </dt>
                            </dl>

                            <div class="mycostat">
                                <div class="mystat stat0" v-if="coinfo.iscancel"><span></span>已撤回</div>
                                <div class="mystat curstat" :style="{backgroundColor:getcurstat(coinfo.stat).colorhex}" v-else><span></span>{{getcurstat(coinfo.stat).title}}</div>
                                <div class="mystatbtn" v-if="ismine && coinfo.stat<9 && !coinfo.iscancel"><a href="#" class="btn3" @click="coback()">撤回投诉</a></div>
                            </div>
                        </div>
                        <dl class="codinfo">
                            <dd class="b"><span>我的身份：</span>{{coinfo.mytypetitle}}</dd>
                            <dd class="b"><span>投诉对象：</span>{{coinfo.targettypetitle}}</dd>
                            <dd class="b"><span>投诉内容：</span>{{$common.basic.strremovehtml(coinfo.content)}}</dd>
                            <dd class="b"><span>投诉要求：</span>{{coinfo.reqtitle}}</dd>
                            <dd class="b" v-if="ismine"><span>是否公开：</span>{{coinfo.isprivate?'否':'是'}}</dd>
                            <dd class="b" v-if="ismine"><span>联系人：</span>{{coinfo.linkman}}</dd>
                            <dd class="b" v-if="ismine"><span>联系手机：</span>{{coinfo.mobile}}</dd>



                            <dd><ffcounts :options="coinfo.x_counts"></ffcounts></dd>
                        </dl>


                    </div>
                    <div class="codcon">
                        <div class="codfinish" v-if="coinfo.stat==9 && coinfo.x_score">
                            <dl class="codscore" v-for="(item,index) in finishinfo.scorepart" :key="index">
                                <dt>{{item}}</dt>
                                <dd>
                                    <span v-for="item2 in 5" :key="item2">
                                        <i v-if="item2<=coinfo.x_score[index]" class="iconfont icon-jiaxingshoucangtianchong"></i>
                                        <i v-else class="iconfont icon-jiaxingshoucang"></i>
                                    </span>
                                </dd>
                            </dl>
                        </div>
                        <div class="codfinish" v-if="ismine && coinfo.stat==8">
                            <dl class="codscore" v-for="(item,index) in finishinfo.scorepart" :key="index">
                                <dt>{{item}}</dt>
                                <dd>
                                    <span v-for="item2 in 5" :key="item2" @mouseover="setfinishscore(index,item2)">
                                        <i v-if="item2<=finishinfo.score[index]" class="iconfont icon-jiaxingshoucangtianchong"></i>
                                        <i v-else class="iconfont icon-jiaxingshoucang"></i>
                                    </span>
                                </dd>
                            </dl>
                            <div class="codfinishcon">
                                <el-input type="textarea" rows="3" placeholder="投诉评价" v-model="finishinfo.content"></el-input>
                            </div>
                            <div class="codfinishbtn"><a href="#" class="btn3" @click="cofinish()">完成投诉</a></div>
                        </div>

                        <div class="codconitem" v-for="item2 in coinfo.x_cosub" :key="item2.id">
                            <dl class="codconmem">
                                <dd><img :src="item2.x_avatar" /></dd>
                                <dt>
                                    <span class="a">
                                        {{item2.x_showname }}
                                    </span><span class="b">{{item2.isplatform?getcurstat(item2.stat).tips:item2.stat==9?'用户确认完成':''}}</span>{{$common.basic.dateformat(item2.publishdate,'yyyy-MM-dd hh:mm:ss')}}
                                </dt>

                            </dl>

                            <div class="codconinfo editor2" v-if="item2.contentshow" v-html="item2.contentshow"></div>

                            <div class="codconimgs" v-if="item2.imgs" v-viewer>
                                <dl>
                                    <dd v-for="(item3,index3) in item2.x_imgs" :key="index3">
                                        <ffimg :imgsrc="item3" :isstatic="true"></ffimg>
                                    </dd>
                                </dl>

                            </div>
                        </div>
                        <div class="codconitem">
                            <dl class="codconmem">
                                <dd><img :src="coinfo.x_avatar" /></dd>
                                <dt>
                                    <span class="a">{{coinfo.x_showname}}</span><span class="b">发起投诉</span>{{$common.basic.dateformat(coinfo.publishdate,'yyyy-MM-dd hh:mm:ss')}}
                                </dt>

                            </dl>
                            <div class="codconinfo editor2" v-html="coinfo.content"></div>

                            <div class="codconimgs" v-if="coinfo.imgs" v-viewer>
                                <dl>
                                    <dd v-for="(item3,index3) in coinfo.x_imgs" :key="index3">
                                        <ffimg :imgsrc="item3" :isstatic="true"></ffimg>
                                    </dd>
                                </dl>

                            </div>
                        </div>

                    </div>

                </div>

                <div class="codattach" v-if="isload">
                    <div class="mycomment" v-if="!coinfo.iscancel && coinfo.stat>1">
                        <div class="mycommenttitle">发布评论</div>
                        <template v-if="$store.state.islogin">
                            <template v-if="coinfo.iscomment && parglobal.iscomment">
                                <div class="mycommentinput">
                                    <el-input type="textarea" rows="3" placeholder="评价内容" v-model="commentinfo.content"></el-input>
                                </div>
                                <dl class="mycommentbtn">
                                    <dt>
                                        <el-checkbox v-if="parglobal.isanoncomment" v-model="commentinfo.isanon" :true-label="1" :false-label="0">匿名</el-checkbox>
                                    </dt>
                                    <dd>
                                        <template v-if="parglobal.iscommentvcode">
                                            <el-input :maxlength="4" placeholder="验证码" v-model="vcode" size="mini" class="txt"></el-input>
                                            <img :src="vcodeimg" @click="getvcode" />
                                        </template>
                                        <a href="#" class="btn3" @click="sendcomment()">发布</a>
                                    </dd>
                                </dl>
                            </template>
                            <div v-else class="txtforbid">{{parglobal.txtcomment}}</div>
                        </template>
                        <div v-else class="txtforbid"><a href="#" class="linkbtn" @click="gopage('login')">登录</a>或<a href="#" class="linkbtn" @click="gopage('login',1)">注册</a>后可以进行评论</div>
                    </div>
                    <div class="cocomment" v-if=" parglobal.isshowcomment && $common.basic.isarrayexist(commentlist)">
                        <div class="cocommenttitle">最新评论</div>
                        <div class="cocommentlist" v-if="iscommentload">
                            <div class="cocommentitem" v-for="item in commentlist" :key="item.id">
                                <div class="ccavatar">
                                    <img :src="item.x_avatar" :title="item.x_showname" />
                                </div>
                                <div class="ccinfo">
                                    <dl class="ccmember">
                                        <dt>
                                            {{$common.basic.strgetlen(item.x_showname,8)}}<span>{{$common.basic.dateformat(item.publishdate,'yyyy-MM-dd hh:mm:ss')}}</span>
                                        </dt>
                                        <dd>
                                            <span title="赞" v-if="item.iszanme" class="idid divlink" @click="setzan(item)"><i class="iconfont icon-zantianchong"></i>{{item.zancount}}</span>
                                            <span title="赞" v-else class="divlink" @click="setzan(item)"><i class="iconfont icon-zan1"></i>{{item.zancount}}</span>
                                        </dd>
                                    </dl>
                                    <div class="editor2" v-html="item.content"></div>
                                </div>
                            </div>
                        </div>

                        <div class="myinfoload" v-if="iscommentloading">
                            <i class="el-icon-loading"></i>正在加载
                        </div>
                    </div>
                </div>

            </div>
        </myScroll>
    </div>



</template>

<script>
    import { mixinpage } from "@/mixin/mixin"

    export default {
        name: 'Cinfodetail',
        mixins: [mixinpage],
        data() {
            return {
                coinfo: {},
                statlist: [],
                commentinfo: {
                    content: '',
                    isanon: '',
                    targetid: 0
                },
                vcode: '',
                vcodeimg: '',
                res: {},
                ismine: false,
                iscommentload: false,
                iscommentloading: false,
                commentlist: [],
                finishinfo: {
                    content: '',
                    score: [0, 0, 0],
                    scorepart: ['服务态度：', '处理速度：', '满意度：']
                }
            }
        },
        methods: {
            getvcode() {
                this.$common.fetch({ 'act': 'vcode', 'msg': '' }, res => {
                    this.vcodeimg = this.$store.state.pngpre + res.vcodeimg;
                });
            },
            getdata: function () {
                let jsondata = { 'postdata': { 'act': 'sht_info_detail', 'id': this.parpage.id } };
                this.$common.post(jsondata, res => {
                    if (res.iserror) {
                        this.gopage('home');
                        return;
                    }

                    res.infodata.x_comments = res.infodatacomments || {};
                    res.infodata.x_ismyzan = res.ismyzan;
                    res.infodata.x_ismycomment = res.ismycomment;

                    if (res.infodata.infotype == 1) {
                        res.infodata.x_mem = res.infodatamember;
                        res.infodata.x_avatar = res.infodata.isanon ? '' : res.infodatamember.avatar;
                        res.infodata.x_avatar = this.$common.getavatar(res.infodata.x_avatar);
                        res.infodata.x_showname = res.infodata.isanon ? this.parglobal.txtanon : res.infodatamember.showname || this.parglobal.txtanon;
                        res.infodata.x_score = '';
                        this.$common.each(res.infodatacosub, item => {
                            item.x_imgs = [];
                            if (item.imgs) {
                                item.x_imgs = item.imgs.split(',');
                            }
                            if (item.isplatform) {
                                item.x_avatar = this.$store.state.config.imgdomain + '/upfile/36/images/shtlogo.png';
                                item.x_showname = this.parglobal.platform;
                            }
                            else {
                                item.x_avatar = res.infodata.x_avatar;
                                item.x_showname = res.infodata.x_showname;
                            }
                            if (item.stat == 9) {
                                if (item.score) {
                                    item.score += ",,";
                                    res.infodata.x_score = item.score.split(',');
                                }
                            }
                        });
                        res.infodata.x_cosub = res.infodatacosub;
                        res.infodata.x_imgs = [];
                        if (res.infodata.imgs) {
                            res.infodata.x_imgs = res.infodata.imgs.split(',');
                        }

                        res.infodata.x_tartype = '';
                        let itemtartype = this.$common.basic.fffind(res.infodatatartype, 'id', res.infodata.tartype);
                        if (this.$common.basic.isobjexist(itemtartype)) {
                            res.infodata.x_tartype = itemtartype.title;
                        }
                    }


                    res.infodata.x_counts = {
                        viewcount: res.infodata.viewcount,
                        comments: res.infodata.x_comments.comments || 0,
                        zancount: res.infodata.zancount,
                        iscommentme: res.infodata.x_ismycomment,
                        iszanme: res.infodata.x_ismyzan,
                        iszancan: !res.infodata.iscancel,
                        targetid: res.infodata.id
                    }

                    this.coinfo = res.infodata;
                    this.statlist = res.infodatastat;
                    this.ismine = res.ismine == 1;
                    this.isload = true;
                    this.getvcode();
                    this.getcomment();
                });
            },
            sendcomment: function () {
                let ischeck = false;
                if (this.commentinfo.content) {
                    this.commentinfo.content = this.commentinfo.content.trim()
                    if (this.commentinfo.content.length >= 10) {
                        ischeck = true;
                    }
                }

                if (!ischeck) {
                    this.$common.alert('评论内容不能少于10字符');
                    return;
                }

                if (this.parglobal.iscommentvcode) {
                    if (!this.vcode) {
                        this.$common.alert('请输入验证码');
                        return false;
                    }
                }

                this.$common.confirm('确认提交发布吗？', () => {
                    this.commentinfo.targetid = this.coinfo.id;
                    let jsondata = { 'postdata': { 'act': 'sht_commentsave', 'vcode': this.vcode, 'data': this.commentinfo } };
                    this.$common.post(jsondata, () => {
                        this.commentinfo.content = '';
                        this.$common.success(this.parglobal.txtcommentcheck);

                    });
                });
            },
            getcomment: function () {
                if (this.$common.basic.isobjexist(this.res)) {
                    if (this.res.cpage > this.res.pagemax) {
                        return false;
                    }
                }

                this.iscommentloading = true;
                let jsondata = {
                    'postdata': { 'act': 'sht_comment', 'id': this.coinfo.id, 'cpage': this.res.cpage || 1 }, 'msg': ''
                };
                this.$common.post(jsondata, res => {
                    this.res = res;
                    this.$common.each(res.infodata, item => {
                        item.iszanme = false;
                        if (this.$store.state.islogn) {
                            let itemmyzan = this.$common.basic.fffind(res.infodatamyzan, 'targetid', item.id);
                            item.iszanme = this.$common.basic.isobjexist(itemmyzan);
                        }


                        item.x_avatar = '';
                        item.x_showname = '';
                        let itemmember = this.$common.basic.fffind(res.infodatamember, 'id', item.mid);

                        if (this.$common.basic.isobjexist(itemmember)) {
                            item.x_avatar = itemmember.avatar;
                            item.x_showname = itemmember.showname;
                        }
                        item.x_avatar = item.isanon ? '' : item.x_avatar;
                        item.x_avatar = this.$common.getavatar(item.x_avatar);
                        item.x_showname = item.isanon ? this.parglobal.txtanon : item.x_showname || this.parglobal.txtanon;

                    });

                    this.iscommentload ? this.commentlist.push(...res.infodata) : this.commentlist = res.infodata;
                    this.iscommentload = true;
                    this.iscommentloading = false;
                });
            },
            handleScroll: function (v) {
                if ((v.process == 1) && !this.iscommentloading) {
                    this.res.cpage++;
                    this.getcomment();
                }
            },
            setzan: function (item) {
                if (this.$store.state.islogin) {
                    let jsondata = {
                        'postdata': { 'act': 'sht_zansave', 'data': { 'targetid': item.id, 'targetkind': 2 } }, 'msg': ''
                    };
                    this.$common.post(jsondata, res => {
                        item.zancount += res.zan;
                        item.iszanme = res.zan == 1;
                    });
                }
            },
            getcurstat: function (v) {
                return this.$common.basic.fffind(this.statlist, 'kv', v);
            },
            coback: function () {
                this.$common.confirm('确认要撤回投诉吗？', () => {
                    let jsondata = { 'postdata': { 'act': 'sht_coback', 'id': this.coinfo.id }, 'msg': '正在撤回' };
                    this.$common.post(jsondata, () => {
                        this.gopage('home', 100);

                    });
                });
            },
            cofinish: function () {
                this.$common.confirm('确认要完成投诉吗？', () => {
                    let jsondata = {
                        'postdata': { 'act': 'sht_codone', 'id': this.coinfo.id, 'data': { 'score': this.finishinfo.score.join(), 'content': this.finishinfo.content } }, 'msg': '正在完成'
                    };
                    this.$common.post(jsondata, () => {
                        this.gopage('home', 100);

                    });
                });
            },
            setfinishscore(index, v) {
                this.$set(this.finishinfo.score, index, v);
            }
        },
        mounted() {
            this.getdata();
        },
        watch: {
            'vcode': function (val) {
                if (val.length == 4) {
                    this.$common.fetch({
                        'act': 'vcodecheck', 'msg': '', 'isautoback': false, 'exts': val
                    }, res => {
                        if (res.bv != 1) {
                            this.$common.alert('验证码错误');
                        }
                    });
                }
            }
        }
    }
</script>
